





















































import { Editor } from '@tiptap/core';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class ActionTextAlign extends Vue {
  @Prop()
  editor!: Editor;
}
